var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-handler"},[( _vm.questionType === 'OPEN_TEXT_SINGLE' || _vm.questionType === 'OPEN_NUMERIC' )?_c('div',[_c('InputField')],1):( _vm.questionType === 'LIST_SINGLE' )?_c('div',[_c('RadioField')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }